<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <div class="banner-header">
    <div class="banner-header__content">
      <h2>{{ 'MODALS.' + modalType + '.title' | translate }}</h2>
      <h3>{{ 'MODALS.' + modalType + '.subtitle' | translate }}</h3>
    </div>
    <div class="banner-header__image">
      <img [src]="'/assets/images/' + modalType + '-modal-header.png'" />
    </div>
  </div>
  <div class="banner-content" [class.banner-campaign]="modalType === 'growChf300'">
    <ul *ngIf="listItems$ | async as listItems">
      <li *ngFor="let item of listItems" [innerHTML]="item | translate"></li>
    </ul>
    @if (modalType === 'growChf300') {
      <p class="banner-terms" [innerHTML]="'MODALS.growChf300.terms' | translate"></p>
    }
    <ion-button mode="ios" expand="block" (click)="openBannerLink()">{{ 'MODALS.' + modalType + '.cta' | translate }}</ion-button>
    <a *ngIf="modalType === 'i4k'" class="link" target="_blank" [href]="articleLink">{{ 'MODALS.' + modalType + '.link' | translate }}</a>
  </div>
</ion-content>
